export const handleRedirect = redirectDetails => {
  if (redirectDetails?.isOpenInNewTab) {
    window.open(redirectDetails?.redirectUrl, '_blank');
  } else if (redirectDetails?.isExternalLink) {
    window.location.href = redirectDetails?.redirectUrl;
  } else {
    window.location.replace(redirectDetails?.redirectUrl);
  }
};
